import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
export function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  const galleryImages = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/buaEbiSb4jmPEJud9op1b2/IMG_9013.jpg',
    title: 'Complete Custom Build - GMC',
    category: 'Complete Package'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dxq9n3rfeuwvuRg3PjKrTf/IMG_9014.jpg',
    title: 'Purple Chrome Wrap & Tint - GMC',
    category: 'Wrap & Tint'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8ig2Zuvb3f9hUFMG58x2XU/IMG_9015.jpg',
    title: 'Performance Upgrade - Ford Super Duty',
    category: 'Performance'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/piNR18jFKdmFMSpEV8vVte/IMG_9016.jpg',
    title: 'Matte Blue Wrap - Sport Bike',
    category: 'Wrapping'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aQT7RZUN6L7zwyUtEcQRQX/IMG_9017.jpg',
    title: 'Purple Chrome Complete Package - Silverado',
    category: 'Complete Package'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7xYk954SUx4eAqDNViJimi/IMG_9018.jpg',
    title: 'Color-Shift Wrap - Dodge Durango',
    category: 'Wrapping'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ageifQTaxDP4ZmaugTFmDU/IMG_9019.jpg',
    title: 'Professional Window Tint - Dodge Ram',
    category: 'Tinting'
  }];
  return <div className="w-full bg-black" data-id="element-186">
      <Helmet data-id="element-187">
        <title data-id="element-188">Gallery - Western Royal Diesel</title>
        <meta name="description" content="View our portfolio of diesel performance upgrades, vehicle wraps, and window tinting projects" data-id="element-189" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16 md:py-24 border-b border-cyan-500/20" data-id="element-190">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-cyan-400 to-green-400 bg-clip-text text-transparent" data-id="element-192">
            Customer Gallery
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl" data-id="element-193">
            Check out some of our recent projects and see the quality of work we
            deliver to our customers.
          </p>
        </div>
      </section>
      {/* Gallery Grid */}
      <section className="py-16 md:py-24 bg-gray-950" data-id="element-194">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-196">
            {galleryImages.map((image, index) => <div key={index} className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer border border-cyan-500/20 hover:border-cyan-500/60 transition-all hover:scale-105" onClick={() => setSelectedImage(index)} data-id="element-197">
                <img src={image.url} alt={image.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" data-id="element-198" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-199">
                  <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-200">
                    <p className="text-white font-semibold text-lg" data-id="element-201">
                      {image.title}
                    </p>
                    <p className="text-cyan-400 text-sm" data-id="element-202">{image.category}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Lightbox Modal */}
      {selectedImage !== null && <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4" onClick={() => setSelectedImage(null)} data-id="element-203">
          <div className="relative max-w-5xl w-full" data-id="element-204">
            <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-cyan-400 z-10 transition-colors" data-id="element-205">
              ×
            </button>
            <img src={galleryImages[selectedImage].url} alt={galleryImages[selectedImage].title} className="w-full h-auto rounded-lg border border-cyan-500/30" data-id="element-206" />
            <div className="text-white text-center mt-4" data-id="element-207">
              <p className="text-xl font-semibold" data-id="element-208">
                {galleryImages[selectedImage].title}
              </p>
              <p className="text-cyan-400" data-id="element-209">
                {galleryImages[selectedImage].category}
              </p>
            </div>
          </div>
        </div>}
    </div>;
}